import { render, staticRenderFns } from "./ConversationList.vue?vue&type=template&id=1724ede7&scoped=true"
import script from "./ConversationList.vue?vue&type=script&lang=js"
export * from "./ConversationList.vue?vue&type=script&lang=js"
import style0 from "./ConversationList.vue?vue&type=style&index=0&id=1724ede7&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1724ede7",
  null
  
)

export default component.exports